<template>
  <div>
    <ViewTemplateWithSalveCancel :panel="panel">
      <div slot="content-buttons">
        <Button
          v-if="id"
          _key="btnTaxationCreate"
          title="Servico"
          classIcon="fas fa-plus-circle"
          type="primary"
          size="small"
          :clicked="create"
        />
      </div>
      <div slot="content-main">
        <TaxationCreateUpdate :formName="panel.formName" />
      </div>
    </ViewTemplateWithSalveCancel>
  </div>
</template>

<script>
import ViewTemplateWithSalveCancel from "@nixweb/nixloc-ui/src/component/template/ViewTemplateWithSalveCancel";
import TaxationCreateUpdate from "../../../components/modules/tax-document/taxation/TaxationCreateUpdate.vue";

import Button from "@nixweb/nixloc-ui/src/component/forms/Button";

import { mapMutations } from "vuex";

export default {
  name: "TaxationCreateUpdateView",
  components: {
    Button,
    ViewTemplateWithSalveCancel,
    TaxationCreateUpdate,
  },
  data() {
    return {
      id: this.$route.params.id,
      panel: {
        module: "Nota Fiscal",
        title: "Servico",
        formName: "taxationCreateUpdate",
        showFilter: false,
        showSearch: false,
        showButtons: true,
      },
    };
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
    create() {
      this.$router.push({
        name: "taxationCreate",
      });
      this.removeLoading(["btnTaxationCreate"]);
    },
  },
};
</script>
